import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from '../store';
import { CommonBaseState, initialCommonBaseState } from "../../interfaces/redux/common";
import { logoutReducers, resetErrors, setError } from "../common/commonActions";
import { loadScheduleEvent, removeScheduleEventsLoaded, setLoading, setLoadingSideMenu } from "./scheduleActions";
import { ScheduleEvent } from "../../interfaces/dtos/schedule";

export interface ScheduleState extends CommonBaseState {
    loadingSideMenu: boolean;

    scheduleEventsLoaded: number[];
    scheduleEvents: ScheduleEvent[];
}

const initialState: ScheduleState = {
    ...initialCommonBaseState,
    loadingSideMenu: false,
    loading: false,

    scheduleEventsLoaded: [],
    scheduleEvents: []
};

export const scheduleSlice = createSlice({
    name: 'schedule',
    initialState,
    reducers: {
        errorOccured: (state, action: PayloadAction<string>) => {
            state.error = true;
            state.errorMessage = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            // removeScheduleEventsLoaded
            .addCase(removeScheduleEventsLoaded.fulfilled, (state) => {
                state.scheduleEventsLoaded = [];
            })
            
            // loadScheduleEvent
            .addCase(loadScheduleEvent.fulfilled, (state, action) => {
                const otherScheduleEvents = state.scheduleEvents.filter((se) => se.eventId !== action.payload.eventId);
                state.scheduleEvents = [...otherScheduleEvents, action.payload];
                state.scheduleEventsLoaded = [...state.scheduleEventsLoaded, action.payload.eventId];
            })

            // Set loading side menu
            .addCase(setLoadingSideMenu.fulfilled, (state, action) => {
                state.loadingSideMenu = action.payload;
            })
            // Set loading item
            .addCase(setLoading.fulfilled, (state, action) => {
                state.loading = action.payload;
            })

            // Set error
            .addCase(setError.fulfilled, (state, action) => {
                state.error = true;
                state.errorMessage = action.payload;
            })
            // Reset feedback
            .addCase(resetErrors.fulfilled, (state) => {
                state.error = false;
            })
            // Logout
            .addCase(logoutReducers.fulfilled, () => {
                return {...initialState};
            });
    }
});

export const { errorOccured } = scheduleSlice.actions;
export const scheduleState = (state: RootState) => state.schedule;
export default scheduleSlice.reducer;
